/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StringQualificationFieldAuthor } from './';
import {
    StringQualificationFieldAuthorFromJSON,
    StringQualificationFieldAuthorFromJSONTyped,
    StringQualificationFieldAuthorToJSON,
} from './';

/**
 * 
 * @export
 * @interface StringQualificationField
 */
export interface StringQualificationField {
    /**
     * 
     * @type {string}
     * @memberof StringQualificationField
     */
    value: string;
    /**
     * 
     * @type {Date}
     * @memberof StringQualificationField
     */
    updateDate?: Date;
    /**
     * 
     * @type {StringQualificationFieldAuthor}
     * @memberof StringQualificationField
     */
    author?: StringQualificationFieldAuthor;
}

/**
 * Check if a given object implements the StringQualificationField interface.
 */
export function instanceOfStringQualificationField(value: object): value is StringQualificationField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function StringQualificationFieldFromJSON(json: any): StringQualificationField {
    return StringQualificationFieldFromJSONTyped(json, false);
}

export function StringQualificationFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringQualificationField {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'updateDate': json['updateDate'] == null ? undefined : (new Date(json['updateDate'])),
        'author': json['author'] == null ? undefined : StringQualificationFieldAuthorFromJSON(json['author']),
    };
}

export function StringQualificationFieldToJSON(value?: StringQualificationField | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'updateDate': value['updateDate'] == null ? undefined : ((value['updateDate']).toISOString()),
        'author': StringQualificationFieldAuthorToJSON(value['author']),
    };
}

